import PropTypes from 'prop-types';

import MilestonesPropType from './milestones';
import ProjectPropTypes from './project';
import ScorePropTypes from './score';

export default PropTypes.shape({
    id: PropTypes.string,
    status: PropTypes.string,
    url: PropTypes.string,
    date: PropTypes.string,
    threshold: PropTypes.number,
    errorCode: PropTypes.string,
    errorMessage: PropTypes.string,
    milestones: MilestonesPropType,
    score: ScorePropTypes,
    project: ProjectPropTypes,
    statsId: PropTypes.string,
    incrementalId: PropTypes.number,
    pageTitle: PropTypes.string,
    pageScreenshot: PropTypes.string,
});
